import script from "./PaymentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentPage.vue?vue&type=script&setup=true&lang=js"

import "./PaymentPage.vue?vue&type=style&index=0&id=198538f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198538f6"]])

export default __exports__